import type { InboxView } from "@/types/inboxView/inboxView";

/** A view's name, or the first line of the prompt it was made from. */
export const inboxViewTitle = (view: InboxView): string => {
  if (view.name && view.name.trim()) return view.name.trim();
  const first = view.prompt.split("\n")[0];
  return first.length > 70 ? `${first.slice(0, 67)}…` : first;
};

/** True while the genie is still working out or filling a view's rows. */
export const isInboxViewSorting = (view?: InboxView): boolean => {
  const status = view?.last_run?.status;
  return status === "pending" || status === "designing" || status === "extracting";
};
